module.exports = __webpack_public_path__ + "static/media/aboutBanner2.502bddfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutBanner2.jpg
// module id = 351
// module chunks = 0